<template>
    <span>{{ formatPrice }}</span>
</template>

<script>
import PriceFormatter from '../../../js/price/PriceFormatter';

export default {
    props: {
        price: {
            type: Object,
            required: true,
        },
        quantityFactor: {
            type: Object,
            required: false,
            default: null,
        },
        withVat: {
            type: Boolean,
            required: false,
            default: false,
        },
        fromNumber: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            priceFormatter: new PriceFormatter(),
        }
    },
    computed: {
        formatPrice() {
            let price;
            if (null === this.quantityFactor) {
                price = this.fromNumber
                    ? this.priceFormatter.formatFromNumber(this.price)
                    : this.priceFormatter.format(this.price);
            } else {
                price = this.fromNumber
                    ? this.priceFormatter.formatFromNumberWithQuantityFactor(this.price, this.quantityFactor)
                    : this.priceFormatter.formatWithQuantityFactor(this.price, this.quantityFactor);
            }
            if (this.withVat) {
                price += ' ' + this.$t('(inkl. {vat} % MwSt.)', {vat: this.priceFormatter.getVat(this.price)});
            }
            return price;
        }
    },
    methods: {
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
